export { default } from "./NumberQuestionCard"